import { render, staticRenderFns } from "./BuyerTicketDetails.vue?vue&type=template&id=6d3f0261&"
import script from "./BuyerTicketDetails.vue?vue&type=script&lang=js&"
export * from "./BuyerTicketDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports